export default function (instance) {
    return {
        getAll(payload) {
            return instance.get(payload);
        },
        getAllCompanies() {
            return instance.get('/Company/GetAll')
        },
        getBaseAllCompanies() {
            return instance.get('/Company/GetBaseAll')
        },
        getAllUserFilter(payload) {
            return instance.get(payload);
        },
        getAllCoreMarketFilter(payload) {
            return instance.get(payload);
        }
    }
}
